<template>
    <div ref="trackview" class="overflow-y-auto h-screen-header">
        <div class="tabs tabs-boxed mb-2 bg-base-100 !flex">
            <div class="flex w-full">
                <div class="flex-1 flex overflow-x-auto overflow-y-hidden scrollbar-hide">
                    <div class="flex whitespace-nowrap items-center">
                        <a
                            v-for="{ value, text } in options"
                            :key="value"
                            :class="{ 'tab': true, 'tab-active': sortValue === value, 'flex-shrink-0': true }"
                        >
                            <router-link :to="{ path: '/tracks/' + value }">
                                {{ $tt(text) }}
                            </router-link>
                        </a>
                    </div>
                </div>
                <div class="flex justify-center items-center flex-shrink-0 ml-2">
                    <a :class="{ 'tab': true, 'tab-active': showMode === 'card' }" @click="showMode = 'card'">
                        <svg class="icon w-5 h-5 fill-current" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
                            <path d="M170.666667 85.333333a85.333333 85.333333 0 0 0-85.333334 85.333334v213.333333a85.333333 85.333333 0 0 0 85.333334 85.333333h213.333333a85.333333 85.333333 0 0 0 85.333333-85.333333V170.666667a85.333333 85.333333 0 0 0-85.333333-85.333334H170.666667zM170.666667 554.666667a85.333333 85.333333 0 0 0-85.333334 85.333333v213.333333a85.333333 85.333333 0 0 0 85.333334 85.333334h213.333333a85.333333 85.333333 0 0 0 85.333333-85.333334v-213.333333a85.333333 85.333333 0 0 0-85.333333-85.333333H170.666667zM640 85.333333a85.333333 85.333333 0 0 0-85.333333 85.333334v213.333333a85.333333 85.333333 0 0 0 85.333333 85.333333h213.333333a85.333333 85.333333 0 0 0 85.333334-85.333333V170.666667a85.333333 85.333333 0 0 0-85.333334-85.333334h-213.333333zM640 554.666667a85.333333 85.333333 0 0 0-85.333333 85.333333v213.333333a85.333333 85.333333 0 0 0 85.333333 85.333334h213.333333a85.333333 85.333333 0 0 0 85.333334-85.333334v-213.333333a85.333333 85.333333 0 0 0-85.333334-85.333333h-213.333333z"></path>
                        </svg>
                    </a>
                    <a :class="{ 'tab': true, 'tab-active': showMode === 'list' }" @click="showMode = 'list'">
                        <svg class="icon w-5 h-5 fill-current" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
                            <path d="M134.976 853.312H89.6c-26.56 0-46.912-20.928-46.912-48.256 0-27.392 20.352-48.32 46.912-48.32h45.376c26.624 0 46.912 20.928 46.912 48.32 0 27.328-20.288 48.256-46.912 48.256zM134.976 560.32H89.6C63.04 560.32 42.688 539.392 42.688 512s20.352-48.32 46.912-48.32h45.376c26.624 0 46.912 20.928 46.912 48.32s-20.288 48.32-46.912 48.32zM134.976 267.264H89.6c-26.56 0-46.912-20.928-46.912-48.32 0-27.328 20.352-48.256 46.912-48.256h45.376c26.624 0 46.912 20.928 46.912 48.256 0 27.392-20.288 48.32-46.912 48.32zM311.744 853.312c-26.56 0-46.912-20.928-46.912-48.256 0-27.392 20.352-48.32 46.912-48.32h622.72c26.56 0 46.848 20.928 46.848 48.32 0 27.328-20.288 48.256-46.912 48.256H311.744c1.6 0 1.6 0 0 0zM311.744 560.32c-26.56 0-46.912-20.928-46.912-48.32s20.352-48.32 46.912-48.32h622.72c26.56 0 46.848 20.928 46.848 48.32s-20.288 48.32-46.912 48.32H311.744c1.6 0 1.6 0 0 0zM311.744 267.264c-26.56 0-46.912-20.928-46.912-48.32 0-27.328 20.352-48.256 46.912-48.256h622.72c26.56 0 46.848 20.928 46.848 48.256 0 27.392-20.288 48.32-46.912 48.32H311.744c1.6 0 1.6 0 0 0z"></path>
                        </svg>
                    </a>
                </div>
            </div>
        </div>
        <div class="w-full overflow-hidden">
            <TrackList v-if="showMode === 'list'" :tracks="albums" :index-field="'index'" />
            <TrackList v-else :tracks="albums" :index-field="'index'" view-mode="card" />
        </div>
        <div class="flex justify-center" v-if="loading">
            <span class="loading loading-infinity loading-lg"></span>
        </div>
        <button
            v-if="curScrollTop > 700"
            @click="scrollToTop"
            class="fixed bottom-8 right-8 bg-neutral-content text-accent-content text-neutral font-bold py-2 px-4 rounded-full shadow-xl transition-colors duration-300 hover:bg-accent"
        >
            <svg t="1730534469934" class="icon h-5 w-5 fill-current" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2399" width="200" height="200"><path d="M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3c-3.8 5.3-0.1 12.7 6.5 12.7h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z" p-id="2400"></path></svg>
        </button>
    </div>
</template>

<script>
import TrackList from './TrackList'
import { mapGetters } from 'vuex'

export default {
    name: 'tracks',
    components: {
        TrackList
    },
    data() {
        return {
            albums: [],
            loading: false,
            offset: 0,
            hasMore: true,
            showMode: 'card',
            curScrollTop: 0,
            watchSearchTerm: null,
            searchTimeout: null
        }
    },
    computed: {
        ...mapGetters(['getSearchTerm', 'trackId']),
        options() {
            return [
                { text: '最近添加', value: 'recently-added' },
                { text: '最近播放', value: 'recently-played' },
                { text: '最多播放', value: 'most-played' },
                { text: 'A-Z排序', value: 'a-z' }
            ]
        },
        sortValue() {
            return this.$route.params.sort
        }
    },
    created() {
        this.resetAndLoad()
        this.watchSearchTerm = this.$watch('getSearchTerm', this.loadSearchTimeout)
    },
    activated() {
        this.bindScrollListener()
        this.restoreScroll()
        this.startWatching()
    },
    deactivated() {
        this.unbindScrollListener()
        this.stopWatching()
    },
    beforeDestroy() {
        this.unbindScrollListener()
        this.stopWatching()
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout)
            this.searchTimeout = null
        }
    },
    mounted() {
        this.bindScrollListener()
        this.restoreScroll()
    },
    methods: {
        bindScrollListener() {
            if (this.$refs.trackview) {
                this.$refs.trackview.addEventListener('scroll', this.listenBottomOut)
                window.trackview = this.$refs.trackview
            }
        },
        unbindScrollListener() {
            if (this.$refs.trackview) {
                this.$refs.trackview.removeEventListener('scroll', this.listenBottomOut, false)
            }
        },
        restoreScroll() {
            if (this.$refs.trackview) {
                this.$refs.trackview.scrollTop = this.curScrollTop || 0
            }
        },
        startWatching() {
            if (!this.watchSearchTerm) {
                this.watchSearchTerm = this.$watch('getSearchTerm', this.loadSearchTimeout)
            }
        },
        stopWatching() {
            if (this.watchSearchTerm) {
                this.watchSearchTerm()
                this.watchSearchTerm = null
            }
        },
        resetState() {
            this.offset = 0
            this.albums = []
            this.hasMore = true
            this.curScrollTop = 0
        },
        resetAndLoad() {
            this.resetState()
            if (this.getSearchTerm) {
                return this.loadSearch()
            }
            return this.loadMore()
        },
        refreshCurrentPage() {
            if (this.loading) {
                return
            }
            return this.resetAndLoad()
        },
        loadMore() {
            if (this.loading || !this.hasMore || this.getSearchTerm) {
                return
            }
            this.loading = true
            return this.$api.subsonic.getTracksByGenre(this.sortValue, 50, this.offset).then(albums => {
                this.albums.push(...albums)
                this.offset += albums.length
                this.hasMore = albums.length > 0
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        loadSearch() {
            if (this.getSearchTerm === '') {
                this.resetState()
                return this.loadMore()
            }
            this.loading = true
            this.offset = 0
            this.hasMore = true
            return this.$api.subsonic.searchTracksByGenre('search', this.getSearchTerm, 30, this.offset).then(albums => {
                this.albums = albums
                this.offset += albums.length
                this.hasMore = albums.length > 0
                this.loading = false
            }).catch((err) => {
                this.loading = false
                if (err.message === 'Wrong username or password.') {
                    this.$myMsg.notify({
                        title: this.$tt('查询失败！'),
                        content: this.$tt('请在后台管理创建一个subsonic密码，刷新页面试试吧'),
                        type: 'error',
                        time: 5000,
                        url: '/admin/user/userprofile/'
                    })
                } else {
                    this.$myMsg.notify({
                        title: this.$tt('查询失败！'),
                        content: err.messagee ? err.message : this.$tt('创建失败'),
                        type: 'error',
                        time: 5000
                    })
                }
            })
        },
        loadSearchTimeout() {
            if (this.searchTimeout) {
                clearTimeout(this.searchTimeout)
            }
            this.searchTimeout = setTimeout(() => {
                this.searchTimeout = null
                this.resetAndLoad()
            }, 500)
        },
        listenBottomOut() {
            if (!this.hasMore || this.loading || this.getSearchTerm || !this.$refs.trackview) {
                return
            }
            const scroller = this.$refs.trackview
            const scrollTop = scroller.scrollTop
            const scrollHeight = scroller.scrollHeight
            const clientHeight = scroller.clientHeight
            this.curScrollTop = scrollTop
            if (scrollTop + clientHeight >= scrollHeight - 120) {
                this.loadMore()
            }
        },
        scrollToTop() {
            if (this.$refs.trackview) {
                this.$refs.trackview.scrollTo({ top: 0, behavior: 'smooth' })
            }
        },
        switchSort(value) {
            if (value === this.sortValue) {
                return
            }
            this.$router.push({ path: '/tracks/' + value })
        },
        playTrack(index) {
            if (this.albums[index].id === this.trackId) {
                return this.$store.dispatch('playPause')
            }
            return this.$store.dispatch('playTrackList', {
                tracks: this.albums,
                index
            })
        },
        playAll() {
            if (!this.albums.length) {
                return
            }
            return this.$store.dispatch('playTrackList', {
                tracks: this.albums,
                index: 0
            })
        },
        playRandom() {
            if (!this.albums.length) {
                return
            }
            const index = Math.floor(Math.random() * this.albums.length)
            return this.playTrack(index)
        }
    }
}
</script>
